$(document).ready(function () {
    const headingSelector =
        ".tpl-content-columns .content-column.collapsible > .heading";

    const promote = function (index, heading) {
        const $heading = $(heading);
        if ($heading.children(".content-column-toggle").length > 0) return;

        const $body = $heading.siblings(".content-column-body");
        const targetId = $body.attr("id");
        if (!targetId) return;

        const expanded = $body.hasClass("show");
        const $toggle = $("<button>", {
            type: "button",
            class: expanded
                ? "content-column-toggle"
                : "content-column-toggle collapsed",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#" + targetId,
            "aria-controls": targetId,
            "aria-expanded": expanded ? "true" : "false",
            text: $heading.text().trim(),
        });

        $heading.empty().append($toggle);
    };

    const demote = function (index, heading) {
        const $heading = $(heading);
        const $toggle = $heading.children(".content-column-toggle");
        if ($toggle.length === 0) return;

        $heading.text($toggle.text());
    };

    let wasDesktop = null;

    const sync = function () {
        const isDesktop = $.mediaQuery("lg");
        if (isDesktop === wasDesktop) return;
        wasDesktop = isDesktop;

        $(headingSelector).each(isDesktop ? demote : promote);
    };

    sync();
    $(window).on("resize", sync);
});
